import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import withColor from 'util/hoc/with-color';

const StyledConfirmInPlace = withColor(styled.div`
  width: 100%;
  display: flex;
  margin: auto;
  position: relative;
  background-color: #f4f4f4;
  transition: all .3s;
  transition-timing-function: cubic-bezier(.21,.08,.46,.93);
  transform: translateX(110%);

  &.animate {
    transform: translateX(0%);
  }

  p {
    flex: 1;
  }

  p, .confirm-actions {
    display: flex;
    align-items: center;
    margin: 0 .5em;

    button {
      &:last-child {
        background-color: ${props => props.colors.auxilaryColor5};
        border-color: ${props => props.colors.auxilaryColor5};
      }

      &.no-button-style {
        padding: .5em;
        font-weight: 600;
        background-color: transparent;
        border-color: transparent;
        color: #b07d00;
        transition: all .15s ease-in-out;

        &:last-child {
          color: ${props => props.colors.auxilaryColor5};
        }
        &:hover {
          text-shadow: 0 1px 4px $grey-1;
        }
      }
    }
  }
`);

const ConfirmInPlace = ({ onComplete, className, noButtonStyle = false, text = "Are you sure?", active, style = {} }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    active ? setAnimate(true) : setAnimate(false);
  });

  return active ? (
    <StyledConfirmInPlace className={`${className} ${animate ? 'animate' : ``}`} style={style}>
      <p>{ text }</p>
      <div className="confirm-actions">
        <button className={noButtonStyle ? 'no-button-style' : ''} onClick={()=>onComplete(true)}>Yes</button>
        <button className={noButtonStyle ? 'no-button-style' : ''} onClick={()=>onComplete(false)}>No</button>
      </div>
    </StyledConfirmInPlace>
  ) : null;
};

export default ConfirmInPlace;
